import React from 'react';
import { Tab, TabList } from '@headlessui/react';
import clsx from 'clsx';
import { useRouteMatch, Link as ReactLink } from 'react-router-dom';

const PageEditNavigation = ({ tabs }) => {
  const match = useRouteMatch();

  return (
    <TabList as={NavList}>
      {tabs.map((tab, index) => (
        <Tab key={index} as={React.Fragment}>
          {({ selected }) => (
            <ReactLink to={`${match.url}${tab.path}`}>
              <button
                type="button"
                className={clsx(
                  `outline-none group flex w-full items-center space-x-2.5 rounded-md px-2.5 transition-all duration-300 hover:text-chocolate-600 p-2`,
                  {
                    'text-chocolate-600 bg-gray-50': selected,
                    'text-gray-900 bg-transparent': !selected,
                  },
                )}
              >
                <NavLinkText selected={selected}>{tab.label}</NavLinkText>
              </button>
            </ReactLink>
          )}
        </Tab>
      ))}
    </TabList>
  );
};

function NavList({ children }) {
  return <ul className="w-full mt-2 list-style-none">{children}</ul>;
}

function NavLinkText({ children }) {
  return <span className={clsx(`align-middle font-medium`)}>{children}</span>;
}

export default PageEditNavigation;
